
import { fontText, StylesIndexInjections } from "common-react";
import { createStyles, makeUiStyles, Theme } from "../../styles/styles";
import { focusStyle } from '../../styles/mixins';


export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    margin: '0px 0px 16px 0px',
    display: 'flex',
    alignItems: 'flex-start',
    '&:has(.Mui-disabled):hover, &:has(.Mui-disabled):active': {
      backgroundColor: 'transparent',
      cursor: 'default',
    },
    '&:has(.Mui-disabled)': {
      opacity: 0.4,
    },
    '&:has(.Mui-focusVisible)': {
      ...focusStyle(theme),
      borderRadius: 4,
    },
    '& .MuiCheckbox-root.Mui-focusVisible, & .MuiRadio-root.Mui-focusVisible': {
      outline: 'none',
      backgroundColor: 'transparent',
    },
    '& .MuiFormControlLabel-label.Mui-disabled': {
      color: theme.color.greys[80]
    }
  },
  label: {
    font: fontText('normal', theme.fontSize.base, 24),
    color: theme.color.greys[80],
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
}), { name: 'FormControlLabel', index: StylesIndexInjections.UI_ATOMS });
